import { ResourceType } from '@mxa-argos/core/graphql/graphql';
import { ChangeSearchItem } from '@mxa-argos/modules/search/components/change-search-item';
import { DeviceSearchItem } from '@mxa-argos/modules/search/components/device-search-item';
import { OrderSearchItem } from '@mxa-argos/modules/search/components/order-search-item';
import { PersonSearchItem } from '@mxa-argos/modules/search/components/person-search-item';
import { PortabilitySearchItem } from '@mxa-argos/modules/search/components/portability-search-item';
import { SimSearchItem } from '@mxa-argos/modules/search/components/sim-search-item';
import { SubscriptionSearchItem } from '@mxa-argos/modules/search/components/subscription-search-item';
import type { SearchResult } from '@mxa-argos/modules/search/hooks/use-resource-search';

interface Props {
  result: SearchResult;
}

export function SearchItemContent({ result }: Props) {
  switch (result.type) {
    case ResourceType.SUBSCRIPTION:
      return <SubscriptionSearchItem result={result} />;
    case ResourceType.DEVICE:
      return <DeviceSearchItem result={result} />;
    case ResourceType.SIM:
      return <SimSearchItem result={result} />;
    case ResourceType.PERSON:
      return <PersonSearchItem result={result} />;
    case ResourceType.ORDER:
      return <OrderSearchItem result={result} />;
    case ResourceType.PORTABILITY:
      return <PortabilitySearchItem result={result} />;
    case ResourceType.CHANGE:
      return <ChangeSearchItem result={result} />;
  }
}
